import { IPredictedLineupsHp, ITeamTypings, PlayerTypings } from '@sky-it-livedata/livedata-sports-design-system';
import { isValidCompetitionPredictedLineups } from './typeguards';
import { CreatePredictedLineupHomepageInputSchema, PredictedLineupMatch, PredictedLineupPlayerList, PredictedLineupTeam } from 'appsync';
import { WidgetError, ErrorName } from '../../../utils/errors';
import { CompetitionPredictedLineupsQuery } from '../types';
import { intcmpMap } from '../../../utils/intcmp';

export const stringToObjectArray = (fullName: string, _isArray: boolean = true) => {
  const player: PlayerTypings.IPlayer = {
    id: null,
    role: null,
    fullName,
  };

  return player;
};

const transformTeam = (team: PredictedLineupTeam): ITeamTypings => {
  const { playerList } = team;
  const { disqualifiedPlayers, manager, potentialPlayers, substitutePlayers, unavailablePlayers, predictedLineup } =
    playerList as PredictedLineupPlayerList;
  return {
    ctaUrl: team.predictedTeamLink ?? '',
    formation: team.formation as ITeamTypings['formation'],
    id: team.id,
    logoUrl: team.negativeLogoUrl || team.logo!,
    name: team.customName!,
    seoName: team.customSeoName ?? undefined,
    shortname: team.teamShortName ?? undefined,
    playerList: {
      disqualifieds: [stringToObjectArray(disqualifiedPlayers!)],
      manager: stringToObjectArray(manager!),
      potentialPlayers: [stringToObjectArray(potentialPlayers!)],
      substitutes: [stringToObjectArray(substitutePlayers!)],
      unavailables: [stringToObjectArray(unavailablePlayers!)],
      startingLineup: predictedLineup!.map((item) => ({
        ...item,
        fullName: item!.fullName,
      })) as PlayerTypings.IPlayer[],
    },
  };
};

export default (obj: CompetitionPredictedLineupsQuery): IPredictedLineupsHp=> {
  if (isValidCompetitionPredictedLineups(obj)) {
    CreatePredictedLineupHomepageInputSchema().parse(obj.data.competitionPredictedLineup, {reportInput: true});

    const { competitionId, createdAt, updatedAt, ...predictedLineups } = obj.data.competitionPredictedLineup;
    return {
      ...predictedLineups,
      matchList: predictedLineups!.matchList!.filter(Boolean).map((_m) => {
        const _match = _m as PredictedLineupMatch;
        const { home, away, lmpLineupLink: ctaLmpUrl, ...match } = _match; // Removes "lmpLineupLink" key

        return {
          ...match,
          ctaUrlAway: transformTeam(away!)?.ctaUrl,
          ctaUrlHome: transformTeam(home!)?.ctaUrl,
          ctaLmpUrl, // ISS-6463
          away: transformTeam(away!),
          home: transformTeam(home!),
        };
      }),
      trackingData: intcmpMap.competitionPredictedLineups,
    } as IPredictedLineupsHp;
  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in CompetitionPredictedLineupsQuery object',
      data: obj
    });
  }
};
